import { render, staticRenderFns } from "./TenderTerms.vue?vue&type=template&id=04b13e9b&scoped=true"
import script from "./TenderTerms.vue?vue&type=script&lang=js"
export * from "./TenderTerms.vue?vue&type=script&lang=js"
import style0 from "./TenderTerms.vue?vue&type=style&index=0&id=04b13e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b13e9b",
  null
  
)

export default component.exports